var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showTotal)?_c('div',[_vm._v(" "+_vm._s(_vm.getTotal())+" ")]):_c('div',[(_vm.currentTime)?_c('div',[_vm._v(" "+_vm._s(_vm.timerView())+" ")]):_c('div',[_vm._v(_vm._s(_vm.showDays ? "00:" : "")+"00:00:00")])])
}
var staticRenderFns = []

export { render, staticRenderFns }